import { tv } from 'tailwind-variants';

export const navigationButtonStyles = tv({
  base: `
    absolute
    top-1/2
    z-10

    flex
    h-10
    w-10

    -translate-y-1/2
    cursor-pointer

    items-center
    justify-center
  `,
  variants: {
    direction: {
      left: `
        left-0
        bg-[linear-gradient(to_left,_transparent_0%,_white_35%,_white_100%)]
      `,
      right: `
        right-0
        bg-[linear-gradient(to_right,_transparent_0%,_white_35%,_white_100%)]
      `,
    },
  },
});
